import { Box, Divider, Tooltip } from '@mui/material';
import { WhatsApp, Phone, ContentCopy } from '@mui/icons-material';
import { useState } from 'react';
import ReactGA from 'react-ga4';
import { IconButton, Dialog } from '@sm-dashboard/ui-components';

interface PhoneModalProps {
  open: boolean;
  onClose: () => void;
  businessName: string;
  phoneNumber: string;
  hasWhatsApp: boolean;
  onWhatsAppClick: () => void;
  onPhoneClick: () => void;
  adId: string;
}

const PhoneModal = ({
  open,
  onClose,
  businessName,
  phoneNumber,
  hasWhatsApp,
  onWhatsAppClick,
  onPhoneClick,
  adId
}: PhoneModalProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyPhone = async () => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy phone number:', error);
    }
  };

  const handleWhatsAppAction = () => {
    ReactGA.event({
      category: 'BusinessAdWa',
      action: 'לחיצה על ווצאפ',
      label: adId
    });
    onWhatsAppClick();
    onClose();
  };

  const handlePhoneAction = () => {
    onPhoneClick();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      title="פרטי התקשרות"
      cancelAction
      primaryAction={{
        label: hasWhatsApp ? 'שלח הודעה' : 'התקשר',
        onClick: hasWhatsApp ? handleWhatsAppAction : handlePhoneAction,
        startIcon: hasWhatsApp ? <WhatsApp /> : <Phone />,
        color: hasWhatsApp ? 'success' : 'primary'
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Box component="h2" sx={{ typography: 'h5', fontWeight: 'bold', color: 'primary.main', m: 0, mb: '0.35em' }}>
          {businessName}
        </Box>
        <Divider sx={{ my: 2 }} />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {hasWhatsApp ? <WhatsApp color="success" /> : <Phone color="primary" />}
          <Box sx={{ typography: 'h6', fontWeight: 'bold', direction: 'ltr' }}>{phoneNumber}</Box>
        </Box>
        <Tooltip title="העתק מספר">
          <IconButton
            shape="circle"
            variant="text"
            color={copied ? 'success' : 'secondary'}
            size="medium"
            aria-label="העתק מספר"
            onClick={handleCopyPhone}
          >
            <ContentCopy fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {copied && (
        <Box sx={{ typography: 'body2', color: 'success.main', textAlign: 'center', mb: 2 }}>המספר הועתק בהצלחה!</Box>
      )}

      <Box sx={{ typography: 'body2', color: 'text.secondary', textAlign: 'center' }}>
        {hasWhatsApp ? 'לחץ על "שלח הודעה" לפתיחת WhatsApp עם הודעה מוכנה' : 'לחץ על "התקשר" לחיוג ישיר למספר'}
      </Box>
    </Dialog>
  );
};

export default PhoneModal;
